export default "__VITE_ASSET__yKc$Xj$O__"